import { IconUsersGroup } from "@tabler/icons-react";
import "./MemberInviteBanner.scss";
import { Text } from "@mantine/core";

interface MemberInviteBannerProps {
  remainingSeats: number;
}

const MemberInviteBanner = ({ remainingSeats }: MemberInviteBannerProps) => {
  return (
    <div className="member-invite-banner">
      <IconUsersGroup className="member-invite-banner-icon" />
      <Text c="#1E1E1E">
        You have <strong>{remainingSeats ?? "loading..."}</strong> remaining{" "}
        {remainingSeats === 1 ? "seat" : "seats"}.
      </Text>
    </div>
  );
};

export default MemberInviteBanner;
